import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.sort.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as d3 from 'd3';
import { themesMixin } from '../../../utils/themes';
import { fixedDecimals } from '../../../utils/vuex';
import drawTextMixin from './d3textMixin.js';
export default {
  name: 'CoreChartDoughnut',
  mixins: [drawTextMixin, themesMixin],
  props: {
    size: {
      type: Number,
      "default": 0
    },
    thickness: {
      type: Number,
      "default": 30
    },
    value: {
      type: Number,
      "default": 0
    }
  },
  computed: {
    color: function color() {
      return this.vuetifyColorHex();
    },
    textColor: function textColor() {
      return this.$store.state.app.UiTheme ? '#ccc' : '#333';
    }
  },
  watch: {
    size: function size() {
      this.draw();
    },
    value: function value() {
      this.draw();
    },
    color: function color() {
      this.draw();
    },
    textColor: function textColor() {
      this.draw();
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.draw();
    });
  },
  methods: {
    draw: function draw() {
      var thickness = Math.min(this.thickness, 50);
      var svgSize = 180;
      var innerRadius = svgSize / 2;
      var outerRadius = svgSize / 2 - thickness;
      var colors = [this.color, '#808080'];

      // clear existing svg content
      d3.select(this.$el).selectAll('*').remove();

      // render "N/A" if value is not a number
      if (isNaN(parseFloat(this.value))) {
        return this.drawNotAvailable();
      }
      var svg = d3.select(this.$el).attr('width', this.size || '100%').attr('height', this.size || '100%').attr('viewBox', "0 0 ".concat(svgSize + 2, " ").concat(svgSize + 2)).append('g').attr('transform', "translate(".concat(svgSize / 2 + 1, ",").concat(svgSize / 2 + 1, ")"));
      var data = {
        value: this.value,
        rest: Math.max(100 - this.value, 0)
      };
      var color = d3.scaleOrdinal().domain(data).range(colors);
      var pie = d3.pie().sort(null).value(function (d) {
        return d.value;
      });
      var dataReady = pie(d3.entries(data));
      svg.selectAll().data(dataReady).enter().append('path').attr('d', d3.arc().innerRadius(innerRadius).outerRadius(outerRadius)).attr('fill', function (d) {
        return color(d.data.key);
      }).attr('opacity', function (d) {
        return d.index === 0 ? 1 : 0.4;
      });
      var margin = (svgSize - outerRadius * 2) / 2 + 8;
      this.drawText("".concat(fixedDecimals(this.value, 2), "%"), {
        fontColor: this.textColor,
        x: margin,
        y: 0,
        width: svgSize - margin * 2,
        height: svgSize
      });
    }
  }
};